'use client';

import { AdZoneDisplay } from '@/components/ads/AdZoneDisplay';

interface AdZoneProps {
  zone: string;
  className?: string;
}

const AdZone = ({ zone, className = '' }: AdZoneProps) => {
  return (
    <AdZoneDisplay 
      zone={zone}
      className={className}
      currentPage="home"
      rotationInterval={30000}
      maxAds={1}
    />
  );
};

export default AdZone;